module.exports = __webpack_public_path__ + "static/media/briefcase.934fc5d1.svg";